// extracted by mini-css-extract-plugin
export var footerRow = "Footer-module--footerRow--3JpMm";
export var socialMedia = "Footer-module--socialMedia--3hFfi";